import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  initials: string;
  color: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  name: 'Marek B.',
  role: 'Trener U16',
  initials: 'MB',
  color: 'from-blue-500/30 to-blue-700/10',
  quote: 'Wcześniej spędzałem mnóstwo czasu na przygotowywaniu treningów. Teraz mam gotową bazę materiałów i pracuje mi się dużo spokojniej.'
}, {
  name: 'Katarzyna R.',
  role: 'Trenerka młodzieży',
  initials: 'KR',
  color: 'from-amber-500/30 to-amber-700/10',
  quote: 'Bardzo uporządkowane materiały. Widać, że to nie są przypadkowe ćwiczenia, tylko coś stworzonego z myślą o realnej pracy trenera.'
}, {
  name: 'Łukasz F.',
  role: 'Trener klubowy',
  initials: 'ŁF',
  color: 'from-emerald-500/30 to-emerald-700/10',
  quote: 'Dużo łatwiej planuję zajęcia i mam większe poczucie kontroli nad całym treningiem. To naprawdę ułatwia codzienną pracę.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-20 px-4" data-id="element-218">
      <div className="max-w-6xl mx-auto" data-id="element-219">
        <div className="text-center mb-10 sm:mb-14" data-id="element-220">
          <span className="inline-block bg-secondary/10 border border-secondary/20 text-secondary font-bold text-xs px-3 py-1.5 rounded-full mb-4" data-id="element-221">
            ⭐ CO MÓWIĄ TRENERZY
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-222">
            Ponad 800 trenerów skorzystało już z tych materiałów.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-223">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 flex flex-col gap-4 hover:border-primary/40 transition-colors" data-id="element-224">
              <div className="flex items-center gap-1 text-secondary text-lg" aria-label="5 stelle su 5" data-id="element-225">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium flex-1" data-id="element-226">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-227">
                <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${t.color} border-2 border-primary/30 flex items-center justify-center flex-shrink-0`} aria-hidden="true" data-id="element-228">
                  <span className="text-text-main font-black text-sm tracking-wide" data-id="element-229">
                    {t.initials}
                  </span>
                </div>
                <div data-id="element-230">
                  <p className="text-text-main font-bold text-sm" data-id="element-231">{t.name}</p>
                  <p className="text-text-sec text-xs font-medium" data-id="element-232">{t.role}</p>
                </div>
                <span className="ml-auto text-check-green text-xs font-bold flex items-center gap-1" title="Zweryfikowana opinia" data-id="element-233">
                  ✓ Zweryfikowana opinia
                </span>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}